//-- Copyright (c) 2021 TMT Insights Group, LLC
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from '@/redux/store';

export const selectFocusCalendarSlice = (state: RootState) => state.focusCalendar;

export const selectFocusCalendarView = createSelector(selectFocusCalendarSlice, (focusCalendar) => focusCalendar.view);

export const selectAvailDetailsById = createSelector(
  selectFocusCalendarSlice,
  (_: RootState, availId: number) => availId,
  (focusCalendarSlice, availId): (typeof focusCalendarSlice.availsById)[string] | undefined => focusCalendarSlice.availsById[availId]
);

export const selectSelectedAvailId = createSelector(selectFocusCalendarSlice, (focusCalendar) => focusCalendar.selectedAvailId);
export const selectIsAvailSelected = createSelector(selectSelectedAvailId, (selectedAvailId) => selectedAvailId !== null);

export const selectSelectedAvailDetails = createSelector(selectFocusCalendarSlice, (focusCalendar) =>
  focusCalendar.selectedAvailId ? focusCalendar.availsById[focusCalendar.selectedAvailId] : null
);

export const selectIsAvailExpanded = createSelector(selectFocusCalendarSlice, ({ isAvailExpanded }) => isAvailExpanded);
export const selectSidePanelTransitionState = createSelector(selectFocusCalendarSlice, ({ sidePanelTransitionState }) => sidePanelTransitionState);

export const selectCalendarStats = createSelector(selectFocusCalendarSlice, (focusCalendar) => focusCalendar.stats);
export const selectCalendarStatsStatus = createSelector(selectFocusCalendarSlice, (focusCalendar) => focusCalendar.statsStatus);
